import React, {useMemo} from 'react';
import SmTemperature from '../../charts/temperature/temperature';
import Card from '@material-ui/core/Card';
import {CardHeader, CardContent} from '@material-ui/core';
import { useTranslation } from 'react-i18next';

interface TemperatureCardProps {
    name: string;
    value: number;
    index: number;
}

const TemperatureCard: React.FC<TemperatureCardProps> = (props: TemperatureCardProps) => {

    const { t } = useTranslation();
    const value = useMemo(() => parseFloat(props.value.toString()).toFixed(1).replace('.', ','), [props.value]);
    const valueToDisplay = useMemo(() => {
        try {
            return parseInt(value, 10) < 99 ? `${value}°C` : t('tempError')
        } catch {
            return t('tempError')
        }
        
    }, [value, t])
    return (
        <Card className='temperature-card'>
            <CardHeader title={props.name} className='temperature-card-header'>
            </CardHeader>
            <CardContent className='temperature-card-content'>
                <SmTemperature value={props.value} index={props.index}/>
                <div className='font-weight-bold mt-2'>
                    <span>{valueToDisplay}</span>
                </div>
            </CardContent>
        </Card>
    )
};

export default TemperatureCard;